import { Box, LinearProgress, Stack, Typography } from '@mui/material';

import { useLanguage } from '../i18n/LanguageContext';

import { formatNumber } from './format';

type UsageMeterProps = { label: string; used: number; limit: number | null };

/** Usage against one licence limit. Warning from 80 %, error at the limit; `null` is unlimited (BR-07). */
export const UsageMeter = ({ label, used, limit }: UsageMeterProps) => {
  const { language, t } = useLanguage();
  const ratio = limit === null || limit === 0 ? (limit === 0 && used > 0 ? 1 : 0) : used / limit;
  const colour = limit === null ? 'primary' : ratio >= 1 ? 'error' : ratio >= 0.8 ? 'warning' : 'primary';

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.75 }}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {formatNumber(used, language)} /{' '}
          {limit === null ? t('common.unlimited') : formatNumber(limit, language)}
        </Typography>
      </Stack>
      <LinearProgress
        variant="determinate"
        color={colour}
        value={limit === null ? 0 : Math.min(100, ratio * 100)}
        sx={{ height: 7 }}
      />
    </Box>
  );
};
